import { IUserActions } from '../store/models/IUserActions'
import { BaseServiceProvider } from './BaseServiceProvider'

class UserActionsServiceProvider extends BaseServiceProvider {
  constructor() {
    super(import.meta.env.VITE_API_BASE_URL, 'useractivity', '1.1', '')
  }

  sendUserActions = async (reqData: IUserActions): Promise<void> => {
    return this.post('cartLostSales', reqData)
      .then(() => {
        return
      })
      .catch(() => {
        // Do nothing.
      })
  }
}

export default new UserActionsServiceProvider()
